import { IPublishOptionSchema } from '../../internalTypes';

export function getSelectedPeriodId(periods: IPublishOptionSchema[]): number | null {
  const paidPeriod = periods.findIndex(({ isPaid }) => isPaid);
  const defaultPeriod = periods.findIndex(({ isDefault }) => isDefault);
  const firstPeriod = periods[0];

  if (paidPeriod > -1) {
    return paidPeriod;
  }

  if (defaultPeriod > -1) {
    return defaultPeriod;
  }

  if (firstPeriod) {
    return 0;
  }

  return null;
}
